import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./index.css";
import { Col, Row } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDetailReportSummaryFormData } from "../../../../redux/slice/DetailReportSummarySlice";
import { fetchCategoryClassificationData } from "../../../../redux/slice/QuickReportSlice";
import { usePic } from "../../../../context/PicProvider";
import { toast } from "react-toastify";
import PhotoAddIcon from "../../../../Assets/icons/photo-scan-icon.svg";

const DetailedReportSummary = () => {
  const { theme, setTheme } = usePic();
  const today = new Date().toISOString().split("T")[0];
  const getCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Add leading zero for single digit hours and minutes
    if (hours < 10) hours = `0${hours}`;
    if (minutes < 10) minutes = `0${minutes}`;

    return `${hours}:${minutes}`;
  };

  const currentTime = getCurrentTime();
  const inputRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categoryClassificationData, setCategoryClassificationData] = useState({
    category: [],
    classfication: [],
  });
  const { detailReportSummaryFormData } = useSelector(
    (state) => state.DetailReport
  );
  const { category_classfication_data, quichReportData } = useSelector(
    (state) => state.QUICKREPORT
  );

  //main state of form
  const [formData, setFormData] = useState(detailReportSummaryFormData);
  //onchange function
  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      const selectedDate = new Date(value);
      const maxDate = new Date(today);
      selectedDate.setHours(0, 0, 0, 0);
      maxDate.setHours(0, 0, 0, 0);
      if (selectedDate > maxDate) {
        toast.error("Toady is maximum date");
      }
      setFormData((prev) => ({
        ...prev,
        date: {
          value: selectedDate > maxDate ? today : value,
          warning: !value ? true : false,
        },
      }));
    } else if (name === "time") {
      // Convert selected time and current time into minutes from midnight
      const getTimeInMinutes = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes; // Convert time to minutes from midnight
      };

      const selectedTimeInMinutes = getTimeInMinutes(value);
      const currentTimeInMinutes = getTimeInMinutes(currentTime);

      if (selectedTimeInMinutes > currentTimeInMinutes) {
        toast.error("Current time is maximum time");
      }

      setFormData((prev) => ({
        ...prev,
        time: {
          value:
            selectedTimeInMinutes > currentTimeInMinutes ? currentTime : value,
          warning: !value ? true : false,
        },
      }));
    } else {
      if (name === "category") {
        const filterarray = category_classfication_data?.data?.Incidents.find(
          (curElm) => curElm.name === value
        );
        setCategoryClassificationData({
          ...categoryClassificationData,
          classfication: filterarray?.description,
        });
      }
      setFormData((prev) => ({
        ...prev,
        [name]: { value: value, warning: !value ? true : false },
      }));
    }
  };

  // validate form data
  const validateForm = () => {
    let data = { ...formData };
    data = {
      ...data,
      category: {
        ...data.category,
        warning:
          !data.category.value ||
          data.category.value === "Category of Incident",
      },
      classification: {
        ...data.classification,
        warning:
          !data.classification.value ||
          data.classification.value === "Classification",
      },
      date: { ...data.date, warning: !data.date.value },
      time: { ...data.time, warning: !data.time.value },
    };
    setFormData({ ...data });
    if (
      !data.category.warning &&
      !data.classification.warning &&
      !data.time.warning &&
      !data.date.warning
    ) {
      dispatch(setDetailReportSummaryFormData(formData));
      navigate("/detailedreportaction");
    }
  };

  useEffect(() => {
    // get the data from the backend classification category
    dispatch(fetchCategoryClassificationData());
    const selectedDate = formData.date.value;
    const selectedTime = formData.time.value;
    if (!selectedDate) {
      setFormData((prev) => ({
        ...prev,
        date: { value: today, warning: false },
      }));
    }
    if (!selectedTime) {
      setFormData((prev) => ({
        ...prev,
        time: { value: currentTime, warning: false },
      }));
    }

    const locationOfIncident = {
      value: quichReportData?.kit_data?.location_name ?? "",
      warning: false,
    };
    const areaOfIncident = {
      value: quichReportData?.kit_data?.area ?? "",
      warning: false,
    };
    const forDetails = {
      ...detailReportSummaryFormData,
      locationOfIncident,
      areaOfIncident,
    };

    setFormData((prev) => ({
      ...prev,
      locationOfIncident,
      areaOfIncident,
    }));

    dispatch(setDetailReportSummaryFormData(forDetails));
  }, []);

  //manipulate the backend data as per the frontend
  useEffect(() => {
    const data = {
      category: category_classfication_data?.data?.Incidents?.map(
        (itemIncdients) => {
          return itemIncdients.name;
        }
      ),
      classfication: (
        category_classfication_data?.data?.Incidents?.[0]?.description ?? []
      )?.map((element) => {
        return element;
      }),
    };
    setCategoryClassificationData(data);
  }, [category_classfication_data?.data?.Incidents]);

  const handleAddPhotos = (e) => {
    const filesList = Array.from(e.target.files);
    if (filesList.length > 0) {
      const allAreImages = filesList.every((file) =>
        file.type.startsWith("image/")
      );
      if (allAreImages) {
        const files = e.target.files;
        setTheme([...theme, ...files]);
        e.target.value = "";
      } else {
        toast.error("Please add valid image file");
      }
    }
  };

  return (
    <Form className="detailedReportSummary open-sans-font flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <Row className="row-gap-3 gx-3">
          <Col xs={12}>
            <h6 className="m-0 fw-bold text-center">
              Please provide details on the incident
            </h6>
          </Col>
          <Col xs={12}>
            <Form.Group controlId="formBasicEmail">
              <Form.Select
                aria-label="Default select example"
                className="custom-select-box"
                value={formData.category.value}
                name={"category"}
                onChange={onChange}
              >
                <option value="" disabled className="option-title">
                  Category of Incident
                </option>
                {categoryClassificationData?.category?.map(
                  (categoryItem, index) => (
                    <option value={categoryItem} key={index}>
                      {categoryItem}
                    </option>
                  )
                )}
              </Form.Select>
              {formData.category.warning && (
                <p className="text-danger mt-1 mb-0">Select category</p>
              )}
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group controlId="formBasicEmail">
              <Form.Select
                aria-label="Default select example"
                className="custom-select-box"
                value={formData.classification.value}
                name={"classification"}
                onChange={onChange}
              >
                <option value="" disabled className="option-title">
                  Classification
                </option>
                {categoryClassificationData?.classfication?.map(
                  (descriptionItem, index) => (
                    <option value={descriptionItem} key={index}>
                      {descriptionItem}
                    </option>
                  )
                )}
              </Form.Select>
              {formData.classification.warning && (
                <p className="text-danger mt-1 mb-0">Select classification</p>
              )}
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control
                disabled
                type="text"
                value={formData?.locationOfIncident?.value}
                name="locationOfIncident"
                placeholder="Location"
              />
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control
                disabled
                type="text"
                value={formData.areaOfIncident.value}
                name="areaOfIncident"
                placeholder="Area"
              />
            </Form.Group>
          </Col>
          <Col xs={6}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control
                type="date"
                value={formData.date.value}
                name="date"
                onChange={onChange}
                max={today}
              />
              {formData.date.warning && (
                <p className="text-danger mt-1 mb-0">Enter date</p>
              )}
            </Form.Group>
          </Col>
          <Col xs={6}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control
                type="time"
                name="time"
                value={formData.time.value}
                max={currentTime}
                onChange={onChange}
              />
              {formData.time.warning && (
                <p className="text-danger mt-1 mb-0">Enter time</p>
              )}
            </Form.Group>
          </Col>
          <Col xs={12}>
            <div className="d-flex">
              <img
                src={PhotoAddIcon}
                alt="photo-add-icon"
                style={{ borderRadius: "8px 0px 0px 8px" }}
              />
              <input
                type="file"
                accept="image/*"
                className="d-none"
                ref={inputRef}
                multiple
                onChange={handleAddPhotos}
              />
              <Button
                variant="primary"
                size="lg"
                onClick={() => inputRef.current.click()}
                className="button_custom text-black w-100 btn fw-bold"
                style={{ fontSize: 18, borderRadius: "0px 8px 8px 0px" }}
              >
                Add Photo
              </Button>
            </div>
          </Col>
          {theme.length > 0 && (
            <Col xs={12}>
              <Row className="g-3 collapse show">
                {theme.map((selectItem, index) => (
                  <Col
                    sm={6}
                    md={3}
                    xl={2}
                    key={index}
                    className="d-flex flex-column row-gap-1 fade show"
                  >
                    <img
                      style={{
                        backgroundColor: "#D4D4D4",
                        display: "inline-block",
                        height: "150px",
                        width: "100%",
                      }}
                      src={URL.createObjectURL(selectItem)}
                      alt={`image-${index + 1}`}
                    />
                    <button
                      className="btn text-center w-100"
                      onClick={(event) => {
                        event.preventDefault();
                        let data = [...theme];
                        data.splice(index, 1);
                        setTheme([...data]);
                      }}
                      style={{ color: "#FA0000" }}
                    >
                      Remove
                    </button>
                  </Col>
                ))}
              </Row>
            </Col>
          )}
          <Col xs={12}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control
                as="textarea"
                placeholder="Brief Summary"
                style={{ height: "150px" }}
                value={formData.summary.value}
                name="summary"
                onChange={onChange}
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink to="/detailedreportinfo" className="nav-link">
          <Button variant="dark fw-bold h-100" type="button">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            variant="primary"
            type="button"
            className="button_custom fw-bold text-black"
            onClick={validateForm}
          >
            Continue
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default DetailedReportSummary;
